define('app/models/b2b_contact_form_model',['app/setup'], function(takhfifan) {
  takhfifan.b2bContactFormModel = Backbone.Model.extend({
      validation: {
        'company': {
            required: true,
            msg: i18n.t('company_missing')
        },
        'city': {
            required: true,
            msg: i18n.t('city_missing')
        },
        'name': {
            required: true,
            msg: i18n.t('name_missing')
        },
        'telephone': {
            required: true,
            msg: i18n.t('telephone_missing')
        },
        'email': [{
            required: true,
            msg: i18n.t('email_missing')
          }, {
            pattern: 'email',
            msg: i18n.t('email_invalid')
        }],
        'personnel': [{
            required: true,
            msg: i18n.t('personnel_missing')
          }, {
            pattern: 'number',
            msg: i18n.t('personnel_invalid')
        }],
        'comment': {
            required: true,
            msg: i18n.t('comment_missing')
        },
      }
  });
});

